import { Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ToastController } from "ionic-angular";
import { AlertController, NavController, NavParams } from "ionic-angular";
import { Observable } from "rxjs/Observable";
import { CommitteePage } from "../../pages/committee/committee";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";
import { ValidationserviceProvider } from "../../providers/dbservice/validationservice";
import { ConfigService } from '../../providers/dbservice/configservice';

@Component({
  selector: "page-committee_update",
  templateUrl: "committee_update.html",
})
export class CommitteeUpdatePage {
  private committeeForm: FormGroup;
  private committee;
  private styleName: string ="";

  constructor(private configService: ConfigService,public navCtrl: NavController, public navParams: NavParams,
    private formBuilder: FormBuilder, private db: DbserviceProvider,
    private alertCtrl: AlertController,
    private toastCtrl: ToastController,
  ) {
    console.log("CommitteeUpdatePage constructor");
    this.styleName=this.configService.getConfig("STYLENAME");
    this.committee = this.navParams.get("committee");
    this.committeeForm = this.formBuilder.group({
      "co_active_flg": ["", Validators.required],
      "co_email": ["", [Validators.required, ValidationserviceProvider.emailValidator]],
      "co_fromdate": ["", Validators.required],
      "co_name": ["", [Validators.required]],
      "co_todate": ["", Validators.required],
      "co_id": [""],
      "cp_id": [""],
    });
  }

  private ionViewWillEnter() {
    console.log("CommitteeUpdatePage ionViewWillEnter");
    this.onInitPage();
  }

  private onInitPage() {
    console.log("CommitteeUpdatePage onInitPage");
    this.committeeForm.controls.co_id.setValue(this.navParams.data.committee.co_id);
    this.committeeForm.controls.cp_id.setValue(this.navParams.data.committee.cp_id);
    this.committeeForm.controls.co_name.setValue(this.navParams.data.committee.co_name);
    this.committeeForm.controls.co_email.setValue(this.navParams.data.committee.co_email);
    this.committeeForm.controls.co_fromdate.setValue(this.navParams.data.committee.co_fromdate);
    this.committeeForm.controls.co_todate.setValue(this.navParams.data.committee.co_todate);
    if (this.navParams.data.committee.co_active_flg == "1") {
      this.committeeForm.controls.co_active_flg.setValue(true);
    } else {
      this.committeeForm.controls.co_active_flg.setValue(false);
    }
  }

  private ngOnDestroy() {
    console.log("CommitteeUpdatePage ngOnDestroy");
  }

  private goback() {
    console.log("CommitteeUpdatePage goback");
    this.navCtrl.pop();
  }

  private updateCommittee(value: any) {
    console.log("CommitteeUpdatePage updateCommittee");

    const formValues: any = {
      "co_active_flg": value.co_active_flg,
      "co_email": value.co_email,
      "co_fromdate": value.co_fromdate,
      "co_id": value.co_id,
      "cp_id": value.cp_id,
      "co_name": value.co_name,
      "co_todate": value.co_todate,
    }
    this.committeeForm.controls.cp_id.setValue(this.navParams.data.committee.cp_id);

    // if active flag is set to true, all other committees muste be set as inactive

    this.db.dbCol({ "action": "update", "mapObject": "committee", ...formValues })
      .subscribe((ret) => {
        this.navCtrl.pop();
      });
    //}

  }

  private deleteCommittee(co_id: string) {
    console.log("CommitteeUpdatePage deleteCommittee");
    this.showConfirm("Committee", "Delete Committee: " + this.navParams.data.committee.co_name + "?", co_id);
  }

  private showConfirm(title: string, message: string, co_id: string) {
    console.log("CommitteeUpdatePage showConfirm");
    let confirm = this.alertCtrl.create({
      "buttons": [
        {
          "handler": () => {

            this.db.dbCol({ "action": "dml", "mapObject": "dml", "query": "DELETE FROM committee WHERE committee.co_id = " + this.navParams.data.committee.co_id })
              .subscribe((ret3) => {
                this.navCtrl.pop();
              });

          },
          "text": "Yes",
        },
        {
          "handler": () => { },
          "text": "No",
        },
      ],
      "message": message,
      "title": title,
    });
    confirm.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/committee/committee_update.ts